import { FaqService } from "@vahak/core/dist/_services/faq.service";
import { useDefaultTopLayout } from "components/layout/layout-methods";

export const getLogisticsServicesPageLayout = useDefaultTopLayout;

export const getLogisticsServicesStaticProps = async () => {
    const { faqs } = await FaqService.getFaqsByCateg({
        categSlug: "logistics-services"
    });

    return { faqs };
};
